<template>
    <div class="row col-12">
        <!--Usage
        <date-time-range :startTime.sync="startTime"
                         :endTime.sync="endTime"
                         :useLocalTime="true">
        </date-time-range>-->
        <div class="form-group col-md-6 col-sm-12">
            <label class="font-weight-bold" :class="required ? 'required' : ''" :for="'startTime' + _uid">{{ $t(startTitle) }}</label>
            <!--{{datePickerItem.startMinDate}}
            {{datePickerItem.startMaxDate}}-->
            <div :id="'startTime' + _uid">
                <date-picker ref="startDatePicker"
                             :id="'startTime' + _uid"
                             :name="'startTime' + _uid"
                             v-model="startTimeModel"
                             v-validate="required ? 'required' : ''"
                             :data-vv-as="$t(startTitle)"
                             :required="false"
                             :min="datePickerItem.startMinDate"
                             :max="datePickerItem.startMaxDate"
                             :format="dateTimeCustomFormat"
                             :showTime="showTime"
                             :readonly="readonly"
                             :showOnlyYear="showOnlyYear"
                             :convertDateToUtc="convertDateToUtc"
                             :bindPopup="bindPopup"
                             :popupContainerId="popupContainerId"
                             aria-describedby="startHelp"
                             @input="startChange"></date-picker>
                <small id="startHelp" class="form-text text-muted">{{ $t(startDescription) }}</small>
                <span class="text-danger" v-if="errors.has('startTime' + _uid)">{{ errors.first('startTime' + _uid) }}</span>
            </div>
        </div>
        <div class="form-group col-md-6 col-sm-12">
            <label class="font-weight-bold" :class="required ? 'required' : ''" :for="'endTime' + _uid">{{ $t(endTitle) }}</label>
            <!--{{datePickerItem.endMinDate}}
            {{datePickerItem.endMaxDate}}-->
            <div :id="'endTime' + _uid">
                <date-picker ref="endDatePicker"
                             :id="'endTime' + _uid"
                             :name="'endTime' + _uid"
                             v-model="endTimeModel"
                             v-validate="required ? 'required' : ''"
                             :data-vv-as="$t(endTitle)"
                             :required="false"
                             :min="datePickerItem.endMinDate"
                             :max="datePickerItem.endMaxDate"
                             :format="dateTimeCustomFormat"
                             :showTime="showTime"
                             :readonly="readonly"
                             :showOnlyYear="showOnlyYear"
                             :convertDateToUtc="convertDateToUtc"
                             :bindPopup="bindPopup"
                             :popupContainerId="popupContainerId"
                             aria-describedby="endHelp"
                             @input="endChange"></date-picker>
                <small id="endHelp" class="form-text text-muted">{{ $t(endDescription) }}</small>
                <span class="text-danger" v-if="errors.has('endTime' + _uid)">{{ errors.first('endTime' + _uid) }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import DatePicker from '../../components/datepicker/DateTimePicker';
    import { mapGetters } from 'vuex';

    export default {
        inject: ['$validator'],
        props: {
            startTime: {
                type: [Date, String],
                required: false
            },
            endTime: {
                type: [Date, String],
                required: false
            },
            required: {
                type: Boolean,
                default: false
            },
            format: {
                type: String
            },
            showTime: {
                type: Boolean,
                default: false
            },
            readonly: {
                type: Boolean,
                default: false
            },
            min: {
                type: [Date, String],
                required: false
            },
            max: {
                type: [Date, String],
                required: false
            },
            showOnlyYear: {
                type: Boolean,
                default: false
            },
            startTitle: {
                type: String,
                default: 'registers.forms.editor.validFrom'
            },
            endTitle: {
                type: String,
                default: 'registers.forms.editor.validTo'
            },
            startDescription: String,
            endDescription: String,
            convertDateToUtc: {
                type: Boolean,
                default: true
            },
            bindPopup: {
                type: Boolean,
                default: false
            },
            popupContainerId: {
                type: String,
                default: ''
            },
        },
        components: {
            DatePicker
        },
        data() {
            return {
                datePickerItem: {},
                startTimeModel: null,
                endTimeModel: null, 
            };
        },
        methods: {
            startChange(e) {
                this.$emit('update:startTime', this.startTimeModel);

                let startDate = this.startTimeModel;
                let endDate = this.endTimeModel;

                if (startDate) {
                    startDate = new Date(startDate);
                    startDate.setDate(startDate.getDate());

                    this.datePickerItem.endMinDate = startDate;
                } else if (endDate) {
                    this.datePickerItem.startMaxDate = new Date(endDate);
                } else {
                    endDate = new Date();
                    this.datePickerItem.startMaxDate = endDate;
                    this.datePickerItem.endMinDate = endDate;
                }
            },
            endChange(e) {
                this.$emit('update:endTime', this.endTimeModel);

                let startDate = this.startTimeModel;
                let endDate = this.endTimeModel;

                if (endDate) {
                    endDate = new Date(endDate);
                    endDate.setDate(endDate.getDate());

                    this.datePickerItem.startMaxDate = endDate;
                } else if (startDate) {
                    this.datePickerItem.endMinDate = new Date(startDate);
                } else {
                    endDate = new Date();
                    this.datePickerItem.startMaxDate = endDate;
                    this.datePickerItem.endMinDate = new Date(startDate);
                }
            }
        },
        computed: {
            ...mapGetters(['dateTimeFormat']),
            dateTimeCustomFormat() {
                return this.format ? this.format : this.dateTimeFormat;
            }
        },
        watch: {
            startTime: function (val) {
                this.startTimeModel = val;
            },
            endTime: function (val) {
                this.endTimeModel = val;
            }
        },
        created() {
            if (this.min) {
                this.datePickerItem.startMinDate = this.min;
                this.datePickerItem.endMinDate = this.min;
            }

            if (this.max) {
                this.datePickerItem.startMaxDate = this.max;
                this.datePickerItem.endMaxDate = this.max;
            }

            this.startTimeModel = this.startTime;
            this.endTimeModel = this.endTime;
        },
        mounted() { }
    };
</script>
